<template>
  <div class="fieldset">
    <div class="address" ref="addressElement">
      <label class="fieldset-title">{{title}}</label>
      <fieldset class="address-fieldset">
        <autocomplete
            :value="addressValue"
            :get-label="getLabel"
            :items="autocompleteSource"
            :component-item="itemTemplate"
            :wait="200"
            :min-len="3"
            :input-attrs="autocompleteAddressAttrs"
            :auto-select-one-item="false"
            @item-clicked="select"
            @update-items="search"
            @focus="onInputFocus"
            @blur="onInputBlur"
        />
        <span class="address-directory" ref="threePoints" @click="editable ? openClientAddress() : ''"><img
            src="../image/directory.svg"></span>
      </fieldset>
      <span class="map-button" :class="{'map-button-pressed' : displayed}" title="На карте"
            @click="editable ? openMap() : ''"><img
          src="../image/map-button.svg"></span><span class="move-button handle" title="Переместить"><img
        src="../image/move.svg"></span><!-- Не переносить span на новую строку, а то в Firefox съедет крестик -->
      <div v-if="deleteButtonVisible" @click="editable ? deleteAddr() : ''" class="delete-button" title="Удалить">
        <span class="delete"><img src="../image/cancel.svg"></span>
      </div>
    </div>
    <div class="address-comment">
      <fieldset>
        <input type="text" v-model="address.comment" :disabled="!editable"
               placeholder="Дополнительно: квартира, корпус, другое">
      </fieldset>
      <span class="contact-button" title="Контактное лицо"
            v-show="!contactPersonData"
            @click="editable ? showContactPersonWindow() : ''"><img src="../image/contact.svg"></span>
      <div class="contact" v-show="contactPersonData">
        <span @click="editable ? showContactPersonWindow() : ''">{{ contactPersonData }}</span>
      </div>
    </div>
    <div :id="mapId" v-show="displayed" class="map">
    </div>
  </div>
</template>

<script>
  import Autocomplete from 'v-autocomplete'
  import AddressItemTemplate from '@/views/AddressItemTemplate'
  import {EventBus} from '@/event-bus.js'
  import _ from 'lodash'
  import utils from '@/utils'
  import api from '@/api'

  export default {
    name: 'Address',
    props: ['order', 'clientAddresses', 'isForPetrolService', 'editable'],
    components: {
      Autocomplete,
      AddressItemTemplate
      // AddressContactPerson
    },

    data() {
      return {
        addressKey: this.$uuid.v1(),
        displayed: false,
        mapId: '',
        counter: 0,
        showNoSavedAddressesMessage: false,
        map: {},
        autocompleteSource: [],
        placeMark: {},
        forceReloadAddress: false,
        isListVisible: false,
        contactPersonWindowVisibility: false,
        itemTemplate: AddressItemTemplate
      }
    },

    computed: {
      title() {
        if (this.order === 0) {
          let addressArr = this.isForPetrolService
              ? this.$store.getters.addressesForPetrolService.length
              : this.$store.getters.addresses.length
          if (addressArr == 1) {
            return 'Куда'
          } else {
            return 'Откуда'
          }
        } else if (this.order === 1) {
          return 'Куда'
        } else {
          return 'Еще куда'
        }
      },

      address: {
        get() {
          if (!!this.forceReloadAddress) {
            // имитация Autocomplete.$forceUpdate() - сбросить и заново выставить address, не портя $store.state
            this.$nextTick(() => {
              this.forceReloadAddress = false;
            });
            return utils.getDefaultAddress();
          } else {
            return this.isForPetrolService
                ? this.$store.state.addressesForPetrolService[this.order]
                : this.$store.state.addresses[this.order]
          }
        },

        set(address) {
          if (!!address && address.lat != null && address.lng != null) {
            this.isForPetrolService
                ? this.$store
                    .dispatch('updateAddressForPetrolService', {
                      index: this.order,
                      address: address
                    })
                : this.$store
                    .dispatch('updateAddress', {
                      index: this.order,
                      address: address
                    });
          } else {
            this.forceReloadAddress = true;
          }
        }
      },

      addressValue: {
        get() {
          // if (!!this.forceReloadAddress)
          //   return null;
          // else
          let addressPlace = (!!this.address && this.address.lat != null && this.address.lng != null) ? this.address.place : ''

          return {
            value: addressPlace,
            label: addressPlace,
            isCompany: this.address.isCompanyAddress
          }
        }
      },

      contactPersonData: {
        get() {
          let contactPersonName = this.address.contactPersonName
          let contactPersonPhone = this.address.contactPersonPhone

          return (this.address.contactPersonPhone ? this.address.contactPersonPhone : '') +
              (this.address.contactPersonName
                  ? (this.address.contactPersonPhone ? ', ' : '') + this.address.contactPersonName : '')
        }
      },

      autocompleteAddressAttrs() {
        return {
          disabled: !this.editable
        }
      },

      deleteButtonVisible() {
        return this.order > 0 || this.isForPetrolService
      }
    },

    watch: {
      address: {
        handler: function (newValue) {
          this.updateMap();
        },
        deep: true
      }
    },

    created() {
      this.initMap();
    },

    mounted() {
      EventBus.$on('save-address-contact', payload => {
        if (this.addressKey === payload.addressKey) {
          this.saveContactPersonData(payload)
        }
      })
    },

    methods: {
      initMap() {
        this.mapId = Math.random()
            .toString(36)
            .slice(2)

        ymaps.ready(() => {
          let mapCenter
          if (!!this.address && this.address.lat != null && this.address.lng != null) {
            mapCenter = [this.address.lat, this.address.lng]
          } else {
            let referenceAddress = utils.getReferenceAddress()
            mapCenter = [referenceAddress.lat, referenceAddress.lng]
          }

          this.map = new ymaps.Map(this.mapId, {
            center: mapCenter,
            zoom: 12
          })
          this.placemark = new ymaps.Placemark(
              this.map.getCenter(),
              {},
              {
                draggable: true
              }
          )
          this.placemark.events.add('dragend', evt => {
            let coords = evt.get('target').geometry.getCoordinates()
            this.geocode(coords)
          })
          this.map.geoObjects.add(this.placemark)
          this.map.events.add('click', e => {
            let coords = e.get('coords')
            this.geocode(coords)
          })
        })
      },

      updateMap() {
        if (!this.map || !this.placemark)
          return;

        let lat = this.address.lat;
        let lng = this.address.lng;
        if (lat == null && lng == null) {
          let referenceAddress = utils.getReferenceAddress();
          lat = referenceAddress.lat;
          lng = referenceAddress.lng;
        }

        let coords = [lat, lng];

        this.placemark.geometry.setCoordinates(coords);
        this.map.setCenter(coords);
      },

      openMap() {
        this.displayed = !this.displayed
      },

      deleteAddr() {
        this.isForPetrolService
            ? this.$store
                .dispatch('deleteAddressForPetrolService', this.order)
            : this.$store
                .dispatch('deleteAddress', this.order);
      },

      onInputFocus() {
        this.$refs.threePoints.classList.add('directory-focus')
      },

      onInputBlur() {
        this.$refs.threePoints.classList.remove('directory-focus');

        // this.address = null; // имитация Autocomplete.$forceUpdate() (см. address.set(), address.get())
      },

      search(text) {
        ymaps.suggest(text, {
          // Не работает, требует массив из двух точек
          // boundedBy: [ // Грубые очертания Татарстана
          //   [54.333244, 47.082371],
          //   [55.360203, 47.302097],
          //   [56.646635, 48.993992],
          //   [56.116358, 52.004246],
          //   [56.701069, 52.971043],
          //   [55.665673, 54.542087],
          //   [53.835876, 53.465427],
          //   [54.326823, 49.587253],
          //   [54.333244, 47.082371]
          // ]
          boundedBy: [
            // Прямоугольник, в который почти полностью помещается Татарстан
            [56.531459, 47.807468], // чуть ниже г.Йошкар-Ола
            [54.198191, 54.289402] // рядом с г.Белебей
          ]
        }).then(items => {
          items.sort((a, b) => {
            if (a.value.includes('Казань') && !b.value.includes('Казань')) {
              return -1
            }
            if (!a.value.includes('Казань') && b.value.includes('Казань')) {
              return 1
            }
            return 0
          })

          this.autocompleteSource = items.map(item => {
            return {
              value: item.value,
              label: item.value,
              isCompany: false
            }
          })
        }).then(() => {
          api.getCompaniesFromDaData(text)
              .then(suggestions => {
                this.autocompleteSource = this.autocompleteSource.filter(i => !i.isCompany);
                suggestions
                    .forEach(suggestion => {
                      this.autocompleteSource.push({
                        label: suggestion.value + ' (' + this.getMainAddressFromCompanyAddress(suggestion.data.address.data) + ')',
                        value: suggestion,
                        isCompany: true
                      });
                    })
              })
        });
      },

      /* Отображамое в input значение */
      getLabel(addressValue) {
        return addressValue ?
          addressValue.isCompany ?
            addressValue.value :
            utils.getSmallAddressFromFull(addressValue.value) :
          ''
      },

      select(item) {
        if (item.isCompany) {

          let tmpAddress = {
            lat: item.value.data.address.data.geo_lat,
            lng: item.value.data.address.data.geo_lon,
            place: this.getMainAddressFromCompanyAddress(item.value.data.address.data),
            comment: this.getCommentFromCompanyAddress(item.value.data.address.data),
            isCompanyAddress: true
          };

          this.address = Object.assign(this.address, tmpAddress);
          return;
        }

        if (!item) {
          return
        }

        this.geocode(item.value)
            .then(geocodedObject => {
              let address = _.find(this.clientAddresses, function (address) {
                return address.place === this.address.place
              })
              if (address) {
                this.address.comment = address.comment
              }
            })
            .catch(() => {
              console.log('Адрес не найден')
            })
      },

      geocode(addressOrCoords) {
        return ymaps.geocode(addressOrCoords).then(res => {
          let geocodedObject;
          if (Array.isArray(addressOrCoords)) {
            // Если координаты - берём первый из массива ответов, т.к. результат наверняка точный
            geocodedObject = res.geoObjects.get(0);
          } else {
            // Для поиска по адресу ищем наиболее подходящий переданному запросу,
            // т.к. у Яндекс не всегда корректная сортировка результатов
            let addressParts = addressOrCoords
                .split(',')
                .map(addressPart => addressPart.trim())
                .filter(addressPart => addressPart);
            let maxOverlap = 0;
            res.geoObjects.each((curGeoObject) => {
              let geoObjectAddress = curGeoObject.properties.get('text');
              let overlap = addressParts.filter(addressPart => geoObjectAddress.indexOf(addressPart) != -1).length;
              if (overlap > maxOverlap) {
                maxOverlap = overlap;
                geocodedObject = curGeoObject;
              }
            });
          }

          let coords = geocodedObject.geometry.getCoordinates()
          let text = geocodedObject.properties.get('text')

          this.address = Object.assign(this.address, {
            lat: coords[0],
            lng: coords[1],
            place: text
          });

          return geocodedObject
        })
      },

      openClientAddress() {
        this.isListVisible = !this.isListVisible
        if (this.isListVisible) {
          if (this.clientAddresses) {
            this.autocompleteSource = this.clientAddresses.map(item => {
              return {
                value: item.place,
                label: item.place,
                isCompany: false
              }
            })
            this.$refs.addressElement
                .getElementsByClassName('v-autocomplete-input')[0]
                .focus()
          } else {
            this.autocompleteSource = []
            this.$refs.addressElement
                .getElementsByClassName('v-autocomplete-input')[0]
                .focus()
            alert('Нет сохранённых адресов!')
          }
        } else {
          this.$refs.addressElement
              .getElementsByClassName('v-autocomplete-input')[0]
              .blur()
        }
      },

      showContactPersonWindow() {
        EventBus.$emit('edit-address-contact', {
          addressKey: this.addressKey,
          contactPersonName: this.address.contactPersonName,
          contactPersonPhone: this.address.contactPersonPhone,
          changeShadowVisibility: !this.isForPetrolService
        })
      },

      saveContactPersonData(payload) {
        if (this.$store.getters.waitingApiRequestsCount != 0) {
          return
        }

        this.$store.dispatch('waitingApiRequestsCount', true)
            .then(() => {
              let address = this.address
              address.contactPersonName = payload.contactPersonName
              address.contactPersonPhone = payload.contactPersonPhone
              this.address = address
            })
            .finally(() => {
              this.$store.dispatch('waitingApiRequestsCount', false)
            })
      },

      getCommentFromCompanyAddress(companyAddress) {
        let resultComment = '';

        if (companyAddress.flat_type)
          resultComment += companyAddress.flat_type + ' ' + companyAddress.flat;

        return resultComment;
      },

      getMainAddressFromCompanyAddress(companyAddress) {
        let resultComment = '';

        if (companyAddress.street_with_type) {
          resultComment = companyAddress.street_with_type;

          if (companyAddress.house)
            resultComment += ', ' + companyAddress.house;
        }

        return resultComment;
      }
    }
  }
</script>
<style scoped>
  .handle {
    cursor: move;
    cursor: -webkit-grabbing;
  }
</style>
